// shared between all modules

export const FETCH_DATA = 'fetch_data'
export const SEND_DATA = 'send_data'
export const CLEAR_MODULE_STATE = 'clear_module_state'
export const SET_LOAD_FLAG = 'set_load_flag'

// map module

export const FETCH_TRAVEL = 'fetch_route'
export const SET_TRAVEL_LOAD_FLAG = 'set_travel_load_flag'
export const FETCH_CALENDAR = 'fetch_calendar'
export const SET_CALENDAR_LOAD_FLAG = 'set_calendar_load_flag'

export const UPDATE_CRITICAL_EVENT_STATE = 'update_critical_event_state'
export const SEND_USER_FEEDBACK = 'send_user_feedback'

// auth module
export const AUTH_LOGIN = 'auth_login'
export const AUTH_LOGOUT = 'auth_logout'
export const UPDATE_USER_ROLE = 'update_user_role'
export const UPDATE_ADMIN_ROLE = 'update_admin_role'
export const UPDATE_DEBUG_VIEW = 'update_debug_view'
export const UPDATE_MANAGER_RESTRICTED = 'update_manager_restricted'
export const UPDATE_USER_PROFILE = 'update_user_profile'

// statistics module
export const USER_STATISTICS_UPDATE = 'user_statistics_update'

// snackbar module
export const SNACKBAR_OPEN = 'snackbar_open'
